export const BRANCH_ITEMS_EXAMPLES = [
  {
    branch_id: 1,
    branch_name: 'Downtown Branch',
    phone_number: '+1 (555) 123-4567',
    address: '123 Main Street, Downtown, Cityville, State 12345',
    is_active: true
  },
  {
    branch_id: 2,
    branch_name: 'Uptown Branch',
    phone_number: '+1 (555) 987-6543',
    address: '456 Oak Avenue, Uptown, Cityville, State 12345',
    is_active: true
  },
  {
    branch_id: 3,
    branch_name: 'Westside Branch',
    phone_number: null,
    address: '789 Pine Road, Westside, Cityville',
    is_active: false
  }
]

export const BRANCH_TABS = [
  {
    key: 'general',
    name: 'General',
  },
  {
    key: 'staffSchedule',
    name: 'Staff Schedule',
  },
  {
    key: 'services',
    name: 'Services',
  },
  {
    key: 'staff',
    name: 'Staff',
  },
];
